module.exports = new __parcel__URL__("ErrorGeneric.d6dc5451.svg").toString();